// extracted by mini-css-extract-plugin
export default {"tours":"Tours_tours__SVnNv"};